import React, { useEffect, useMemo, useRef, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import _ from "lodash";
import OrderLabel from "../../modules/OrderLabel";
import api_requests from "../../resources/api_requests";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import moment from "moment";
import constant from "../../resources/constant";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import { hide_loader, show_loader } from "../../actions/app";
import {
  ArrowRightFilledCircle,
  ClockIcon,
  CrossCircleFilled,
  Retry,
} from "../../assets/whiteLabelIcon";
import Footer from "../../Footer";
import { useTranslation } from "react-i18next";

const PendingOrders = () => {
  const { is_loading } = useSelector((state) => state.app, shallowEqual);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const serach_param = [
    { title: t("customer_number"), value: "customer_mobile" },
    { title: t("ref_id"), value: "ref_id" },
    { title: t("order_id"), value: "id" },
  ];

  const tab_list = [
    { title: t("out_for_pickup"), value: "OUT_FOR_PICKUP" },
    { title: t("out_for_delivery"), value: "OUT_FOR_DELIVERY" },
  ];

  let { tab } = qs.parse(location.search.slice(1));
  const [selected_search, set_selected_search] = useState("customer_mobile");
  const [selected_tab, set_selected_tab] = useState(
    tab ? tab : "OUT_FOR_PICKUP",
  );
  const [orders, set_orders] = React.useState({});
  const [order_list, set_order_list] = useState([]);
  const [input_val, set_input_val] = useState("");
  const [show_completed, set_show_completed] = useState(tab === "COMPLETED");
  const [is_result_filtered, set_is_result_filtered] = useState(false);
  const slider_ref = useRef();
  const dispatch = useDispatch();
  const loading_scroll = useRef(false);

  useEffect(() => {
    get_orders({});
  }, [selected_tab, show_completed]);

  const get_orders = async ({ token, limit = 20 }, from_clear = false) => {
    const previousScrollTop = slider_ref.current?.scrollTop;
    set_orders({ next: true });
    const filter_object = {
      ...(!_.isEmpty(input_val) &&
        !from_clear && { [selected_search]: input_val }),
    };
    set_is_result_filtered(!_.isEmpty(filter_object));
    try {
      dispatch(show_loader());
      const res = await api_requests.get_orders_list({
        ...filter_object,
        ...(token && { token }),
        limit: limit,
        group: "pending",
        created_at:
          moment().subtract("15", "days").format("YYYY-MM-DD") +
          "," +
          moment().format("YYYY-MM-DD"),
      });
      set_orders(res.data);
      set_order_list(
        token ? _.concat(order_list, res.data.items) : res.data.items,
      );
      dispatch(hide_loader());
    } catch (error) {
      loading_scroll.current = false;
      dispatch(hide_loader());
    } finally {
      loading_scroll.current = false;
      if (slider_ref.current) {
        slider_ref.current.scrollTop = previousScrollTop;
      }
      dispatch(hide_loader());
    }
  };

  const slider_scrolled = () => {
    if (
      slider_ref.current.scrollTop + slider_ref.current.clientHeight + 100 >=
        slider_ref.current.scrollHeight &&
      orders.next &&
      !loading_scroll.current
    ) {
      loading_scroll.current = true;
      get_orders({ token: orders.next });
    }
  };

  const handle_search = () => {
    if (_.isEmpty(input_val)) return;
    get_orders({});
  };

  const handle_clear_filter = () => {
    set_input_val("");
    get_orders({}, true);
  };

  const handle_back_press = () => {
    navigate(-1);
  };

  const handle_input = (e) => {
    if (selected_search == "customer_mobile") {
      if (e.target.value.length > 10) return;
    }
    set_input_val(e.target.value);
  };

  const null_text = useMemo(() => {
    let text = "";
    if (input_val == "") {
      text = t("no_pending_orders");
    } else {
      text =
        selected_search === "customer_mobile" ? (
          <>
            {t("cant_find_any_order")}{" "}
            {t("kindly_check_the_contact_number_and_try_again")}.
          </>
        ) : selected_search === "ref_id" ? (
          <>
            {t("cant_find_any_order")}{" "}
            {t("kindly_check_the_ref_id_and_try_again")}.
          </>
        ) : (
          <>
            {t("cant_find_any_order")}{" "}
            {t("kindly_check_the_order_id_and_try_again")}.
          </>
        );
    }
    return text;
  }, [order_list]);

  return (
    <div className="h-screen px-6 py-5 overflow-hidden">
      <div className="flex items-center gap-2 pb-6" onClick={handle_back_press}>
        <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" />
        <p className="font-custom text-sm font-semibold text-dark_black">
          {t("pending_orders")}
        </p>
      </div>

      <div
        className="mb-4 px-8 py-5 rounded-lg"
        style={{ boxShadow: `0px 0px 8px 0px #A6A6A640` }}
      >
        <div className="flex gap-2 mb-2">
          {_.map(serach_param, (item, index) => (
            <button
              key={`search_item-${index}`}
              className={`btn btn-outline ${
                item.value === selected_search
                  ? "border-secondary"
                  : "border-accents"
              } rounded-full btn-sm`}
              onClick={() => set_selected_search(item.value)}
            >
              <p
                className={`font-custom font-semibold ${
                  item.value === selected_search
                    ? "text-secondary"
                    : "text-accents"
                } text-[10px]`}
              >
                {item.title}
              </p>
            </button>
          ))}
        </div>
        <div
          className={`flex items-center border border-accents rounded-[30px]  px-4 py-2 bg-white mt-4`}
        >
          <input
            id="pac-input"
            type="text"
            placeholder={t('select_filter')}
            className={`w-full text-gray-700 placeholder-gray-500 bg-transparent text-sm focus:outline-none`}
            onChange={handle_input}
            value={input_val}
          />
          <div
            style={{ opacity: _.isEmpty(input_val) ? 0.3 : 1 }}
            onClick={is_result_filtered ? handle_clear_filter : handle_search}
          >
            {is_result_filtered ? (
              <CrossCircleFilled />
            ) : (
              <ArrowRightFilledCircle />
            )}
          </div>
        </div>
      </div>

      {!is_loading && _.isEmpty(order_list) ? (
        <div className="flex flex-col justify-center w-full p-10 items-center text-center h-[52vh]">
          <p className="font-custom text-[10px] font-medium text-dark_gray">
            {null_text}
          </p>
        </div>
      ) : (
        <div
          className="flex flex-col gap-2 overflow-auto p-2"
          style={{
            height: `calc(100vh - 268px - env(safe-area-inset-bottom))`,
          }}
          ref={slider_ref}
          onScroll={slider_scrolled}
        >
          {_.map(order_list, (item, index) => {
            const otp =
              selected_tab === "OUT_FOR_PICKUP"
                ? item?.fulfillment?.pickup?.otp
                : item?.fulfillment?.pickup?.otp;
            return (
              <div
                key={`order_item_${index}`}
                className="border-2 border-accents rounded-lg p-4"
                // onClick={() => navigate(`/order-detail/${item.id}`)}
                onClick={() =>
                  navigate(`/search-rider/${item?.id}?type=pending`)
                }
              >
                {/* <div className="flex justify-between items-center mb-2">
                  <OrderLabel
                    status={constant.ORDER_STATUS[item.fulfillment?.status]?.id}
                  />
                </div> */}
                <div className="mt-0">
                  <ul className="timeline timeline-vertical w-full">
                    <li className="relative flex pb-2">
                      <div
                        className={`absolute left-1 top-2 h-full w-px `}
                        style={{ backgroundColor: "rgba(252, 240, 219, 0.50)" }}
                      ></div>
                      <div
                        className={`absolute top-1 h-2 w-2 rounded-full `}
                        style={{ backgroundColor: "rgba(252, 240, 219, 0.50)" }}
                      ></div>

                      <div className="pl-5 w-full flex justify-between item-baseline">
                        <div>
                          <p className="line-clamp-1 font-bold text-sm font-custom text-dark_black">
                            {item?.sender_detail?.address?.address_line_1}
                          </p>
                          {/* <p className="line-clamp-1 text-[10px] text-gray font-custom font-semibold">
                            {item?.sender_detail?.address?.address_line_2}
                          </p> */}
                          <p className="text-[10px] text-dark_gray font-custom font-semibold">
                            {item?.sender_detail?.name}{" "}
                            <span className="mx-2">|</span>
                            {item?.sender_detail?.mobile}
                          </p>
                        </div>
                        <div className="flex justify-center item-baseline gap-1">
                          <OrderLabel
                            status={
                              constant.ORDER_STATUS[item.fulfillment?.status]
                                ?.id
                            }
                          />
                        </div>
                      </div>
                    </li>

                    <li className="relative flex">
                      <div
                        className={`absolute top-1 h-2 w-2 rounded-full `}
                        style={{ backgroundColor: "rgba(252, 240, 219, 0.50)" }}
                      ></div>

                      <div className="pl-5 w-full flex justify-between items-end">
                        <div>
                          <p className="line-clamp-1 font-bold text-sm font-custom">
                            {item?.customer_detail?.address?.address_line_1}
                          </p>
                          {/* <p className="text-[10px] text-gray font-custom font-semibold">
                            {item?.sender_detail?.address?.address_line_2}
                          </p> */}
                          <p className="text-[10px] text-gray font-custom font-semibold">
                            {item?.customer_detail?.name}
                            <span className="mx-2">|</span>
                            {item?.customer_detail?.mobile}
                          </p>
                        </div>
                        <div className="flex justify-center items-center gap-1">
                          <Retry />
                          <p className="text-secondary text-[10px] font-custom font-semibold">
                            {t("retry")}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <Footer bottom={0} />
    </div>
  );
};

export default PendingOrders;
